const {
    MODE: ENVIRONMENT,
    VITE_DEVELOPMENT_MODE: DEVELOPMENT_MODE,
    VITE_QUERY_CLIENT_MAX_RETRIES: QUERY_CLIENT_MAX_RETRIES,
    VITE_QUERY_CLIENT_STALE_TIME_MS: VITE_QUERY_CLIENT_STALE_TIME_MS,
} = import.meta.env;

export { ENVIRONMENT, DEVELOPMENT_MODE, QUERY_CLIENT_MAX_RETRIES, VITE_QUERY_CLIENT_STALE_TIME_MS };
